import { render, staticRenderFns } from "./DatePickerFormatted.vue?vue&type=template&id=0564ab0d"
import script from "./DatePickerFormatted.vue?vue&type=script&lang=js"
export * from "./DatePickerFormatted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports